module.exports = __webpack_public_path__ + "assets/e82f5a8f41b618e671ea5725ffc2926b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/win/win_1.mp3
 ** module id = 57
 ** module chunks = 0
 **/